import Columns1a873 from "./components/DataExplore/Columns";
export const CustomEditComponentsMap: any = {
    'customedit.DataExplore/Columns': Columns1a873,
}